module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "Bold CharOverride-3"
  }, [_vm._v("Sustainable"), _c('br')]), _c('span', {
    staticClass: "Bold CharOverride-4"
  }, [_vm._v("Badass")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A Zero-Waste Lifestyle Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "Bold CharOverride-6"
  }, [_vm._v("Gittemarie Johansen")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/MangoPublishingLogo(cmyk).png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Coral Gables")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03506367","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SustainableBadass-1.vue
// module id = 63
// module chunks = 0